import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.65 4.335a4.25 4.25 0 0 1 4.906 5.44.75.75 0 1 0 1.43.45 5.75 5.75 0 0 0-6.636-7.36.75.75 0 0 0 .3 1.47M11 6C8.064 4.597 1 11.198 1 15s5.5 6 9 6c6.486 0 10-4.097 10-6.5 0-1.779-1.37-2.338-2.285-2.712-.32-.131-.585-.24-.715-.37-.207-.206-.071-.485.088-.812.226-.462.498-1.02-.088-1.606-1.215-1.216-2.844-.616-3.958-.205-.58.214-1.02.376-1.192.205-.18-.18-.12-.516-.048-.909.127-.695.286-1.571-.802-2.091m4.738 8.624c.2 2.298-2.323 4.436-5.636 4.777-3.313.34-6.16-1.246-6.361-3.543s2.322-4.436 5.635-4.777c3.313-.34 6.162 1.246 6.362 3.543M16.75 6.5a.75.75 0 0 1 .75-.75 2.75 2.75 0 0 1 2.663 3.437.75.75 0 1 1-1.452-.374A1.25 1.25 0 0 0 17.5 7.25a.75.75 0 0 1-.751-.75Zm-6.644 11.706c1.816-.5 2.958-2.106 2.55-3.588-.407-1.482-2.21-2.278-4.026-1.778-1.817.5-2.959 2.106-2.551 3.588.408 1.481 2.21 2.277 4.027 1.778m-.016-3.732a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-3.091 2.057a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSocialMediaSinaWeibo = { render };
export {
  brandSocialMediaSinaWeibo as default,
  render
};
//# sourceMappingURL=brand-social-media-sina-weibo.svg.js.map
